// extracted by mini-css-extract-plugin
export default {"container":"Ol-z","blurb":"Pl-z","links":"Ql-z"};